 //按产品类型筛选


   const screenList = {
     title: '按产品类型筛选',
     conditons: [
       {
         id: 1,
         title: '井下开采',
         type: '井下开采',
         choose: false,
         currentIndex: 0,
         children: [
           {
             id: 1,
             title: '采煤设备',
             type: '采煤设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '滚筒采煤机',
                 type: '滚筒采煤机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '刨煤机',
                 type: '刨煤机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '螺旋钻采煤机',
                 type: '螺旋钻采煤机',
                 choose: false,
               },
               {
                 id: 4,
                 title: '采煤机配件',
                 type: '采煤机配件',
                 choose: false,
               },
             ],
           },
           {
             id: 2,
             title: '工作面支护',
             type: '工作面支护',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '工作面液压支架',
                 type: '工作面液压支架',
                 choose: false,
               },
               {
                 id: 2,
                 title: '端头支架',
                 type: '端头支架',
                 choose: false,
               },
               {
                 id: 3,
                 title: '过渡支架',
                 type: '过渡支架',
                 choose: false,
               },
               {
                 id: 4,
                 title: '巷道支架',
                 type: '巷道支架',
                 choose: false,
               },
               {
                 id: 5,
                 title: '单体液压支柱',
                 type: '单体液压支柱',
                 choose: false,
               },
               {
                 id: 6,
                 title: '金属顶梁',
                 type: '金属顶梁',
                 choose: false,
               },
               {
                 id: 7,
                 title: '液压支架配件',
                 title: '液压支架配件',
                 choose: false,
               },
             ],
           },
           {
             id: 3,
             title: '工作面输送设备',
             type: '工作面输送设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '工作面刮板输送机',
                 type: '工作面刮板输送机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '转载机',
                 type: '转载机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '工作面破碎机',
                 type: '工作面破碎机',
                 choose: false,
               },
               {
                 id: 4,
                 title: '皮带自移装置',
                 type: '皮带自移装置',
                 choose: false,
               },
               {
                 id: 5,
                 title: '玛蒂克（转载机头和带式输送机尾自移装置）',
                 type: '玛蒂克（转载机头和带式输送机尾自移装置）',
                 choose: false,
               },
               {
                 id: 6,
                 title: '刮板输送机配件-链条',
                 type: '刮板输送机配件-链条',
                 choose: false,
               },
               {
                 id: 7,
                 title: '刮板输送机配件-圆环链',
                 type: '刮板输送机配件-圆环链',
                 choose: false,
               },
               {
                 id: 8,
                 title: '回柱绞车',
                 type: '回柱绞车',
                 choose: false,
               },
               {
                 id: 9,
                 title: '调度绞车',
                 type: '调度绞车',
                 choose: false,
               },
             ],
           },
         ],
       },
       {
         id: 2,
         title: '井下掘进',
         type: '井下掘进',
         choose: false,
         currentIndex: 1,
         children: [
           {
             id: 1,
             title: '机械化掘进设备',
             type: '机械化掘进设备',
             choose: false,
             children: [
               {
                 id: 1,
                 choose: false,
                 title: '全断面巷道掘进机',
                 type: '全断面巷道掘进机',
               },
               {
                 id: 2,
                 choose: false,
                 title: '盾构机',
                 type: '盾构机',
               },
               {
                 id: 3,
                 choose: false,
                 title: '岩石掘进机',
                 type: '岩石掘进机',
               },
               {
                 id: 4,
                 choose: false,
                 title: '部分断面掘进机',
                 type: '部分断面掘进机',
               },
               {
                 id: 5,
                 choose: false,
                 title: '悬臂式掘进机',
                 type: '悬臂式掘进机',
               },
               {
                 id: 6,
                 choose: false,
                 title: '掘锚机',
                 type: '掘锚机',
               },
               {
                 id: 7,
                 choose: false,
                 title: '连续式采煤机',
                 type: '连续式采煤机',
               },
               {
                 id: 8,
                 choose: false,
                 title: '掘锚护一体机',
                 type: '掘锚护一体机',
               },
               {
                 id: 9,
                 choose: false,
                 title: '微盾',
                 type: '微盾',
               },
               {
                 id: 10,
                 choose: false,
                 title: '顶管机',
                 type: '顶管机',
               },
               {
                 id: 11,
                 choose: false,
                 title: '竖井掘进机',
                 type: '竖井掘进机',
               },
               {
                 id: 12,
                 choose: false,
                 title: '反井掘进机',
                 type: '反井掘进机',
               },
               {
                 id: 13,
                 choose: false,
                 title: '硐室掘进机',
                 type: '硐室掘进机',
               },
               {
                 id: 14,
                 choose: false,
                 title: '斜井掘进机',
                 type: '斜井掘进机',
               },
               {
                 id: 15,
                 choose: false,
                 title: '掘进机配件',
                 type: '掘进机配件',
               },
             ],
           },
           {
             id: 2,
             title: '矿山法掘进设备',
             type: '矿山法掘进设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '凿岩台车',
                 type: '凿岩台车',
                 choose: false,
               },
               {
                 id: 2,
                 title: '锚杆台车',
                 type: '锚杆台车',
                 choose: false,
               },
               {
                 id: 3,
                 title: '凿岩机',
                 type: '凿岩机',
                 choose: false,
               },
               {
                 id: 4,
                 title: '湿喷台车',
                 type: '湿喷台车',
                 choose: false,
               },
               {
                 id: 5,
                 title: '喷浆机',
                 type: '喷浆机',
                 choose: false,
               },
               {
                 id: 6,
                 title: '撬毛车',
                 type: '撬毛车',
                 choose: false,
               },
               {
                 id: 7,
                 title: '钻装一体机',
                 type: '钻装一体机',
                 choose: false,
               },
             ],
           },
           {
             id: 3,
             title: '后配套系统',
             type: '后配套系统',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '管片拼装机',
                 type: '管片拼装机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '装载机',
                 type: '装载机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '侧卸式矿车',
                 type: '侧卸式矿车',
                 choose: false,
               },
               {
                 id: 4,
                 title: '地下铲运机',
                 type: '地下铲运机',
                 choose: false,
               },
               {
                 id: 5,
                 title: '地下运矿卡车',
                 type: '地下运矿卡车',
                 choose: false,
               },
             ],
           },
           {
             id: 4,
             title: '支护机具',
             type: '支护机具',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '锚杆钻机',
                 type: '锚杆钻机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '巷道修复机',
                 type: '巷道修复机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '张拉机具',
                 type: '张拉机具',
                 choose: false,
               },
               {
                 id: 4,
                 title: '凿岩钎具-钻杆',
                 type: '凿岩钎具-钻杆',
                 choose: false,
               },
               {
                 id: 5,
                 title: '凿岩钎具-钻头',
                 type: '凿岩钎具-钻头',
                 choose: false,
               },
               {
                 id: 6,
                 title: '锚杆',
                 type: '锚杆',
                 choose: false,
               },
               {
                 id: 7,
                 title: '锚索',
                 type: '锚索',
                 choose: false,
               },
               {
                 id: 8,
                 title: '锚固剂',
                 type: '锚固剂',
                 choose: false,
               },
               {
                 id: 9,
                 title: '锚网连扣机',
                 type: '锚网连扣机',
                 choose: false,
               },
             ],
           },
         ],
       },
       {
         id: 3,
         title: '井下运输',
         type: '井下运输',
         choose: false,
         currentIndex: 2,
         children: [
           {
             id: 1,
             title: '皮带运输',
             type: '皮带运输',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '带式输送机',
                 type: '带式输送机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '气浮皮带输送机',
                 type: '气浮皮带输送机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '带式转载机',
                 type: '带式转载机',
                 choose: false,
               },
               {
                 id: 4,
                 title: '滚筒（硫化包胶）',
                 type: '滚筒（硫化包胶）',
                 choose: false,
               },
               {
                 id: 5,
                 title: '自移机尾',
                 type: '自移机尾',
                 choose: false,
               },
               {
                 id: 6,
                 title: '输送带',
                 type: '输送带',
                 choose: false,
               },
               {
                 id: 7,
                 title: '带扣',
                 type: '带扣',
                 choose: false,
               },
               {
                 id: 8,
                 title: '输送带修复技术',
                 type: '输送带修复技术',
                 choose: false,
               },
               {
                 id: 9,
                 title: '托辊',
                 type: '托辊',
                 choose: false,
               },
               {
                 id: 10,
                 title: '清扫器',
                 type: '清扫器',
                 choose: false,
               },
               {
                 id: 11,
                 title: '逆止器',
                 type: '逆止器',
                 choose: false,
               },
               {
                 id: 12,
                 title: '纠偏器',
                 type: '纠偏器',
                 choose: false,
               },
               {
                 id: 13,
                 title: '制动器',
                 type: '制动器',
                 choose: false,
               },
             ],
           },
           {
             id: 2,
             title: '辅助运输——轨道运输',
             type: '辅助运输——轨道运输',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '蓄电池电机车',
                 type: '蓄电池电机车',
                 choose: false,
               },
               {
                 id: 2,
                 title: '架线式电机车',
                 type: '架线式电机车',
                 choose: false,
               },
               {
                 id: 3,
                 title: '采油机牵引车',
                 type: '采油机牵引车',
                 choose: false,
               },
               {
                 id: 4,
                 title: '井下人车',
                 type: '井下人车',
                 choose: false,
               },
               {
                 id: 5,
                 title: '平板车',
                 type: '平板车',
                 choose: false,
               },
               {
                 id: 6,
                 title: '矿车',
                 type: '矿车',
                 choose: false,
               },
               {
                 id: 7,
                 title: '梭车',
                 type: '梭车',
                 choose: false,
               },
               {
                 id: 8,
                 title: '仓式列车',
                 type: '仓式列车',
                 choose: false,
               },
               {
                 id: 9,
                 title: '翻车机',
                 type: '翻车机',
                 choose: false,
               },
               {
                 id: 10,
                 title: '推车机',
                 type: '推车机',
                 choose: false,
               },
               {
                 id: 11,
                 title: '爬车机',
                 type: '爬车机',
                 choose: false,
               },
               {
                 id: 12,
                 title: '阻车器',
                 type: '阻车器',
                 choose: false,
               },
               {
                 id: 13,
                 title: '单轨吊车',
                 type: '单轨吊车',
                 choose: false,
               },
               {
                 id: 14,
                 title: '单轨吊机车',
                 type: '单轨吊机车',
                 choose: false,
               },
               {
                 id: 15,
                 title: '架空乘人装置',
                 type: '架空乘人装置',
                 choose: false,
               },
               {
                 id: 16,
                 title: '齿轨机车',
                 type: '齿轨机车',
                 choose: false,
               },
               {
                 id: 17,
                 title: '卡轨车',
                 type: '卡轨车',
                 choose: false,
               },
             ],
           },
           {
             id: 3,
             title: '辅助运输——无轨运输',
             type: '辅助运输——无轨运输',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '绞车',
                 type: '绞车',
                 choose: false,
               },
               {
                 id: 2,
                 title: '无轨胶轮车',
                 type: '无轨胶轮车',
                 choose: false,
               },
               {
                 id: 3,
                 title: '胶套轮机车',
                 type: '胶套轮机车',
                 choose: false,
               },
               {
                 id: 4,
                 title: '起重设备',
                 type: '起重设备',
                 choose: false,
               },
             ],
           },
           {
             id: 4,
             title: '矿井提升',
             type: '矿井提升',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '提升机',
                 type: '提升机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '箕斗',
                 type: '箕斗',
                 choose: false,
               },
               {
                 id: 3,
                 title: '罐笼',
                 type: '罐笼',
                 choose: false,
               },
               {
                 id: 4,
                 title: '吊桶 ',
                 type: '吊桶 ',
                 choose: false,
               },
               {
                 id: 5,
                 title: '罐道',
                 type: '罐道',
                 choose: false,
               },
               {
                 id: 6,
                 title: '制动器',
                 type: '制动器',
                 choose: false,
               },
               {
                 id: 7,
                 title: '防坠器',
                 type: '防坠器',
                 choose: false,
               },
               {
                 id: 8,
                 title: '斜井提升设备',
                 type: '斜井提升设备',
                 choose: false,
               },
             ],
           },
         ],
       },
       {
         id: 4,
         title: '煤矿机电与动力',
         type: '煤矿机电与动力',
         choose: false,
         currentIndex: 3,
         children: [
           {
             id: 1,
             title: '矿井供配电',
             type: '矿井供配电',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '移动变电站',
                 type: '移动变电站',
                 choose: false,
               },
               {
                 id: 2,
                 title: '变压器',
                 type: '变压器',
                 choose: false,
               },
               {
                 id: 3,
                 title: '组合',
                 type: '组合',
                 choose: false,
               },
               {
                 id: 4,
                 title: '馈电开关',
                 type: '馈电开关',
                 choose: false,
               },
               {
                 id: 5,
                 title: '高压',
                 type: '高压',
                 choose: false,
               },
               {
                 id: 6,
                 title: '低压变频器',
                 type: '低压变频器',
                 choose: false,
               },
               {
                 id: 7,
                 title: '电磁启动器',
                 type: '电磁启动器',
                 choose: false,
               },
               {
                 id: 8,
                 title: '漏电保护装置',
                 type: '漏电保护装置',
                 choose: false,
               },
               {
                 id: 9,
                 title: '保护器',
                 type: '保护器',
                 choose: false,
               },
               {
                 id: 10,
                 title: '低压侧保护箱',
                 type: '低压侧保护箱',
                 choose: false,
               },
               {
                 id: 11,
                 title: '电抗器',
                 type: '电抗器',
                 choose: false,
               },
               {
                 id: 12,
                 title: '电容',
                 type: '电容',
                 choose: false,
               },
               {
                 id: 13,
                 title: '电控箱',
                 type: '电控箱',
                 choose: false,
               },
               {
                 id: 14,
                 title: '矿用电缆',
                 type: '矿用电缆',
                 choose: false,
               },
               {
                 id: 15,
                 title: '电缆连接器',
                 type: '电缆连接器',
                 choose: false,
               },
             ],
           },
           {
             id: 2,
             title: '电机',
             type: '电机',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '防爆电动机',
                 type: '防爆电动机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '电机',
                 type: '电机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '永磁电机',
                 type: '永磁电机',
                 choose: false,
               },
               {
                 id: 4,
                 title: '发电设备',
                 type: '发电设备',
                 choose: false,
               },
               {
                 id: 5,
                 title: '柴油机',
                 type: '柴油机',
                 choose: false,
               },
               {
                 id: 6,
                 title: '发动机',
                 type: '发动机',
                 choose: false,
               },
             ],
           },
           {
             id: 3,
             title: '泵',
             type: '泵',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '乳化液泵站',
                 type: '乳化液泵站',
                 choose: false,
               },
               {
                 id: 2,
                 title: '喷雾泵站',
                 type: '喷雾泵站',
                 choose: false,
               },
               {
                 id: 3,
                 title: '液压泵',
                 type: '液压泵',
                 choose: false,
               },
               {
                 id: 4,
                 title: '柱塞泵',
                 type: '柱塞泵',
                 choose: false,
               },
               {
                 id: 5,
                 title: '注浆',
                 type: '注浆',
                 choose: false,
               },
               {
                 id: 6,
                 title: '压裂泵',
                 type: '压裂泵',
                 choose: false,
               },
               {
                 id: 7,
                 title: '冷却用水泵',
                 type: '冷却用水泵',
                 choose: false,
               },
             ],
           },
           {
             id: 4,
             title: '液压传动 ',
             type: '液压传动 ',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '液压马达',
                 type: '液压马达',
                 choose: false,
               },
               {
                 id: 2,
                 title: '油箱',
                 type: '油箱',
                 choose: false,
               },
               {
                 id: 3,
                 title: '油缸',
                 type: '油缸',
                 choose: false,
               },
               {
                 id: 4,
                 title: '液压缸',
                 type: '液压缸',
                 choose: false,
               },
               {
                 id: 5,
                 title: '液压控制阀',
                 type: '液压控制阀',
                 choose: false,
               },
               {
                 id: 6,
                 title: '轴承',
                 type: '轴承',
                 choose: false,
               },
               {
                 id: 7,
                 title: '联轴器',
                 type: '联轴器',
                 choose: false,
               },
               {
                 id: 8,
                 title: '蓄能器',
                 type: '蓄能器',
                 choose: false,
               },
               {
                 id: 9,
                 title: '齿轮箱',
                 type: '齿轮箱',
                 choose: false,
               },
               {
                 id: 10,
                 title: '减速机',
                 type: '减速机',
                 choose: false,
               },
               {
                 id: 11,
                 title: '减速器',
                 type: '减速器',
                 choose: false,
               },
               {
                 id: 12,
                 title: '逆止器',
                 type: '逆止器',
                 choose: false,
               },
               {
                 id: 13,
                 title: '限矩器',
                 type: '限矩器',
                 choose: false,
               },
               {
                 id: 14,
                 title: '油管',
                 type: '油管',
                 choose: false,
               },
               {
                 id: 15,
                 title: '软管',
                 type: '软管',
                 choose: false,
               },
               {
                 id: 16,
                 title: '管接头',
                 type: '管接头',
                 choose: false,
               },
               {
                 id: 17,
                 title: '保护套',
                 type: '保护套',
                 choose: false,
               },
               {
                 id: 18,
                 title: '冷却器',
                 type: '冷却器',
                 choose: false,
               },
               {
                 id: 19,
                 title: '加热器',
                 type: '加热器',
                 choose: false,
               },
               {
                 id: 20,
                 title: '过滤器',
                 type: '过滤器',
                 choose: false,
               },
               {
                 id: 21,
                 title: '滤芯',
                 type: '滤芯',
                 choose: false,
               },
               {
                 id: 22,
                 title: '液位计',
                 type: '液位计',
                 choose: false,
               },
               {
                 id: 23,
                 title: '密封计',
                 type: '密封计',
                 choose: false,
               },
             ],
           },
           {
             id: 5,
             title: '压气设备',
             type: '压气设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '矿山空气压缩机',
                 type: '矿山空气压缩机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '气动马达',
                 type: '气动马达',
                 choose: false,
               },
               {
                 id: 3,
                 title: '空气过滤器',
                 type: '空气过滤器',
                 choose: false,
               },
               {
                 id: 4,
                 title: '油水分离器',
                 type: '油水分离器',
                 choose: false,
               },
               {
                 id: 5,
                 title: '风包',
                 type: '风包',
                 choose: false,
               },
               {
                 id: 6,
                 title: '储气罐',
                 type: '储气罐',
                 choose: false,
               },
               {
                 id: 7,
                 title: '空气管网',
                 type: '空气管网',
                 choose: false,
               },
             ],
           },
           {
             id: 6,
             title: '钻机',
             type: '钻机',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '定向钻机',
                 type: '定向钻机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '切顶钻机',
                 type: '切顶钻机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '坑道钻机',
                 type: '坑道钻机',
                 choose: false,
               },
               {
                 id: 4,
                 title: '深孔钻车',
                 type: '深孔钻车',
                 choose: false,
               },
               {
                 id: 5,
                 title: '反井钻机',
                 type: '反井钻机',
                 choose: false,
               },
             ],
           },
         ],
       },
       {
         id: 5,
         title: '煤矿辅助生产系统',
         type: '煤矿辅助生产系统',
         choose: false,
         currentIndex: 4,
         children: [
           {
             id: 1,
             title: '排水设备',
             type: '排水设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '潜水泵',
                 type: '潜水泵',
                 choose: false,
               },
               {
                 id: 2,
                 title: '渣浆泵',
                 type: '渣浆泵',
                 choose: false,
               },
               {
                 id: 3,
                 title: '离心泵',
                 type: '离心泵',
                 choose: false,
               },
               {
                 id: 4,
                 title: '矿井水处理设备',
                 type: '矿井水处理设备',
                 choose: false,
               },
             ],
           },
           {
             id: 2,
             title: '通风设备',
             type: '通风设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '离心式',
                 type: '离心式',
                 choose: false,
               },
               {
                 id: 2,
                 title: '轴流式通风机',
                 type: '轴流式通风机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '局部通风机',
                 type: '局部通风机',
                 choose: false,
               },
               {
                 id: 4,
                 title: '抑尘系统',
                 type: '抑尘系统',
                 choose: false,
               },
               {
                 id: 5,
                 title: '除尘风机',
                 type: '除尘风机',
                 choose: false,
               },
               {
                 id: 6,
                 title: '反风装置',
                 type: '反风装置',
                 choose: false,
               },
               {
                 id: 7,
                 title: '扩散器',
                 type: '扩散器',
                 choose: false,
               },
               {
                 id: 8,
                 title: '风筒',
                 type: '风筒',
                 choose: false,
               },
               {
                 id: 9,
                 title: '智能无压风门',
                 type: '智能无压风门',
                 choose: false,
               },
             ],
           },
           {
             id: 3,
             title: '通信、照明设备',
             type: '通信、照明设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '矿用无线通信系统',
                 type: '矿用无线通信系统',
                 choose: false,
               },
               {
                 id: 2,
                 title: '煤矿调度广播通讯系统',
                 type: '煤矿调度广播通讯系统',
                 choose: false,
               },
               {
                 id: 3,
                 title: '矿用视频监控系统',
                 type: '矿用视频监控系统',
                 choose: false,
               },
               {
                 id: 4,
                 title: '矿灯',
                 type: '矿灯',
                 choose: false,
               },
               {
                 id: 5,
                 title: '充电架',
                 type: '充电架',
                 choose: false,
               },
               {
                 id: 6,
                 title: '矿用电话',
                 type: '矿用电话',
                 choose: false,
               },
               {
                 id: 7,
                 title: '防爆矿灯灯具',
                 type: '防爆矿灯灯具',
                 choose: false,
               },
             ],
           },
           {
             id: 4,
             title: '安全生产及救援',
             type: '安全生产及救援',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '安全生产监控系统',
                 type: '安全生产监控系统',
                 choose: false,
               },
               {
                 id: 2,
                 title: '井下防火灭火系统',
                 type: '井下防火灭火系统',
                 choose: false,
               },
               {
                 id: 3,
                 title: '制氮设备及管路',
                 type: '制氮设备及管路',
                 choose: false,
               },
               {
                 id: 4,
                 title: '瓦斯检测抽放系统',
                 type: '瓦斯检测抽放系统',
                 choose: false,
               },
               {
                 id: 5,
                 title: '探水装备',
                 type: '探水装备',
                 choose: false,
               },
               {
                 id: 6,
                 title: '井下救生舱',
                 type: '井下救生舱',
                 choose: false,
               },
               {
                 id: 7,
                 title: '矿井自救抢险装置',
                 type: '矿井自救抢险装置',
                 choose: false,
               },
             ],
           },
           {
             id: 5,
             title: '环境保护设备',
             type: '环境保护设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '矿山环境保护与复垦',
                 type: '矿山环境保护与复垦',
                 choose: false,
               },
               {
                 id: 2,
                 title: '矸石充填设备',
                 type: '矸石充填设备',
                 choose: false,
               },
               {
                 id: 3,
                 title: '三下开采设备',
                 type: '三下开采设备',
                 choose: false,
               },
               {
                 id: 4,
                 title: '废水处理解决方案',
                 type: '废水处理解决方案',
                 choose: false,
               },
               {
                 id: 5,
                 title: '生产生活污水处理设备',
                 type: '生产生活污水处理设备',
                 choose: false,
               },
             ],
           },
         ],
       },
       {
         id: 6,
         title: '自动化控制和煤矿智能化',
         type: '自动化控制和煤矿智能化',
         choose: false,
         currentIndex: 5,
         children: [
           {
             id: 1,
             title: '煤矿自动化控制',
             type: '煤矿自动化控制',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '综采自动化智能化系统',
                 type: '综采自动化智能化系统',
                 choose: false,
               },
               {
                 id: 2,
                 title: '掘进自动化控制系统',
                 type: '掘进自动化控制系统',
                 choose: false,
               },
               {
                 id: 3,
                 title: '智能化矿井运输无人系统',
                 type: '智能化矿井运输无人系统',
                 choose: false,
               },
               {
                 id: 4,
                 title: '矿井提升自动化系统',
                 type: '矿井提升自动化系统',
                 choose: false,
               },
               {
                 id: 5,
                 title: '智能通风系统',
                 type: '智能通风系统',
                 choose: false,
               },
               {
                 id: 6,
                 title: '智能配电监控系统',
                 type: '智能配电监控系统',
                 choose: false,
               },
               {
                 id: 7,
                 title: '泵站健康系统',
                 type: '泵站健康系统',
                 choose: false,
               },
               {
                 id: 8,
                 title: '洗选设备监控',
                 type: '洗选设备监控',
                 choose: false,
               },
               {
                 id: 9,
                 title: '矿山压力监测系统',
                 type: '矿山压力监测系统',
                 choose: false,
               },
               {
                 id: 10,
                 title: '无人值守综合管理系统',
                 type: '无人值守综合管理系统',
                 choose: false,
               },
               {
                 id: 11,
                 title: '智能运维管理系统',
                 type: '智能运维管理系统',
                 choose: false,
               },
               {
                 id: 12,
                 title: '井下人员管理系统',
                 type: '井下人员管理系统',
                 choose: false,
               },
             ],
           },
           {
             id: 2,
             title: '煤矿智能化配套技术',
             type: '煤矿智能化配套技术',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '防爆计算机',
                 type: '防爆计算机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '交换机',
                 type: '交换机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '工业服务器',
                 type: '工业服务器',
                 choose: false,
               },
               {
                 id: 4,
                 title: '光纤和射频',
                 type: '光纤和射频',
                 choose: false,
               },
               {
                 id: 5,
                 title: '遥控器',
                 type: '遥控器',
                 choose: false,
               },
               {
                 id: 6,
                 title: '传感器',
                 type: '传感器',
                 choose: false,
               },
               {
                 id: 7,
                 title: '雷达',
                 type: '雷达',
                 choose: false,
               },
               {
                 id: 8,
                 title: '物联网解决方案',
                 type: '物联网解决方案',
                 choose: false,
               },
               {
                 id: 9,
                 title: '虹膜机',
                 type: '虹膜机',
                 choose: false,
               },
               {
                 id: 10,
                 title: '煤矿机器人',
                 type: '煤矿机器人',
                 choose: false,
               },
             ],
           },
         ],
       },
       {
         id: 7,
         title: '煤炭加工利用',
         type: '煤炭加工利用',
         choose: false,
         currentIndex: 6,
         children: [
           {
             id: 1,
             title: '洗选设备',
             type: '洗选设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '筛分设备',
                 type: '筛分设备',
                 choose: false,
               },
               {
                 id: 2,
                 title: '智能干选设备',
                 type: '智能干选设备',
                 choose: false,
               },
               {
                 id: 3,
                 title: '智能煤矸分选机器人',
                 type: '智能煤矸分选机器人',
                 choose: false,
               },
               {
                 id: 4,
                 title: '筛板',
                 type: '筛板',
                 choose: false,
               },
               {
                 id: 5,
                 title: '压滤机',
                 type: '压滤机',
                 choose: false,
               },
               {
                 id: 6,
                 title: '跳汰机',
                 type: '跳汰机',
                 choose: false,
               },
               {
                 id: 7,
                 title: '浮选机',
                 type: '浮选机',
                 choose: false,
               },
               {
                 id: 8,
                 title: '重介质旋流器',
                 type: '重介质旋流器',
                 choose: false,
               },
             ],
           },
           {
             id: 2,
             title: '煤炭加工利用',
             type: '煤炭加工利用',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '煤化工',
                 type: '煤化工',
                 choose: false,
               },
               {
                 id: 2,
                 title: '煤制油',
                 type: '煤制油',
                 choose: false,
               },
               {
                 id: 3,
                 title: '洁净煤技术',
                 type: '洁净煤技术',
                 choose: false,
               },
             ],
           },
         ],
       },
       {
         id: 8,
         title: '露天采矿',
         type: '露天采矿',
         choose: false,
         currentIndex: 7,
         children: [
           {
             id: 1,
             title: '露天开采设备',
             type: '露天开采设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '露天采煤机',
                 type: '露天采煤机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '电铲',
                 type: '电铲',
                 choose: false,
               },
               {
                 id: 3,
                 title: '液压挖掘机',
                 type: '液压挖掘机',
                 choose: false,
               },
               {
                 id: 4,
                 title: '轮斗挖掘机',
                 type: '轮斗挖掘机',
                 choose: false,
               },
               {
                 id: 5,
                 title: '钻车',
                 type: '钻车',
                 choose: false,
               },
               {
                 id: 6,
                 title: '钻机',
                 type: '钻机',
                 choose: false,
               },
             ],
           },
           {
             id: 2,
             title: '运输设备',
             type: '运输设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '装载机',
                 type: '装载机',
                 choose: false,
               },
               {
                 id: 2,
                 title: '矿用卡车',
                 type: '矿用卡车',
                 choose: false,
               },
               {
                 id: 3,
                 title: '电动宽体车',
                 type: '电动宽体车',
                 choose: false,
               },
               {
                 id: 4,
                 title: '铲运机',
                 type: '铲运机',
                 choose: false,
               },
               {
                 id: 5,
                 title: '矿用自卸汽车',
                 type: '矿用自卸汽车',
                 choose: false,
               },
             ],
           },
           {
             id: 3,
             title: '辅助设备',
             type: '辅助设备',
             choose: false,
             children: [
               {
                 id: 1,
                 title: '旋回',
                 type: '旋回',
                 choose: false,
               },
               {
                 id: 2,
                 title: '颚式破碎机',
                 type: '颚式破碎机',
                 choose: false,
               },
               {
                 id: 3,
                 title: '发电机组',
                 type: '发电机组',
                 choose: false,
               },
             ],
           },
         ],
       },
       {
         id: 9,
         title: '矿山服务与工程',
         type: '矿山服务与工程',
         choose: false,
         currentIndex: 8,
         children: [
           {
             id: 1,
             title: '服务贸易',
             type: '服务贸易',
             choose: false,
             children: [
               {
                 id: 1,
                 choose: false,
                 title: '设计',
                 type: '设计',
               },
               {
                 id: 2,
                 choose: false,
                 title: '咨询服务',
                 type: '咨询服务',
               },
               {
                 id: 3,
                 choose: false,
                 title: '代理贸易',
                 type: '代理贸易',
               },
               {
                 id: 4,
                 choose: false,
                 title: '新闻媒体',
                 type: '新闻媒体',
               },
               {
                 id: 5,
                 choose: false,
                 title: '政府单位',
                 type: '政府单位',
               },
               {
                 id: 6,
                 choose: false,
                 title: '协会组织',
                 type: '协会组织',
               },
               {
                 id: 7,
                 choose: false,
                 title: '教育培训',
                 type: '教育培训',
               },
               {
                 id: 8,
                 choose: false,
                 title: '劳务服务',
                 type: '劳务服务',
               },
               {
                 id: 9,
                 choose: false,
                 title: '金融',
                 type: '金融',
               },
               {
                 id: 10,
                 choose: false,
                 title: '租赁',
                 type: '租赁',
               },
               {
                 id: 11,
                 choose: false,
                 title: '保险',
                 type: '保险',
               },
               {
                 id: 12,
                 choose: false,
                 title: '二手设备',
                 type: '二手设备',
               },
               {
                 id: 13,
                 choose: false,
                 title: '劳动保护及职业健康',
                 type: '劳动保护及职业健康',
               },
               {
                 id: 14,
                 choose: false,
                 title: '软件',
                 type: '软件',
               },
               {
                 id: 15,
                 choose: false,
                 title: '煤机电商',
                 type: '煤机电商',
               },
             ],
           },
           {
             id: 2,
             title: '勘探、建井与工程',
             type: '勘探、建井与工程',
             choose: false,
             children: [
               {
                 id: 1,
                 choose: false,
                 title: '地质勘探',
                 type: '地质勘探',
               },
               {
                 id: 2,
                 choose: false,
                 title: '矿山测量',
                 type: '矿山测量',
               },
               {
                 id: 3,
                 choose: false,
                 title: '矿井建设',
                 type: '矿井建设',
               },
               {
                 id: 4,
                 choose: false,
                 title: '工程承包',
                 type: '工程承包',
               },
               {
                 id: 5,
                 choose: false,
                 title: '托管运营',
                 type: '托管运营',
               },
               {
                 id: 6,
                 choose: false,
                 title: '交钥匙工程',
                 type: '交钥匙工程',
               },
               {
                 id: 7,
                 choose: false,
                 title: '煤层气开发与利用',
                 type: '煤层气开发与利用',
               },
               {
                 id: 8,
                 choose: false,
                 title: '矿井降温',
                 type: '矿井降温',
               },
               {
                 id: 9,
                 choose: false,
                 title: '选煤厂托管运营',
                 type: '选煤厂托管运营',
               },
             ],
           },
         ],
       },
       {
         id: 10,
         title: '矿用物资、工具及加工制造',
         type: '矿用物资、工具及加工制造',
         choose: false,
         currentIndex: 9,
         children: [
           {
             id: 1,
             choose: false,
             title: '矿用物资材料',
             type: '矿用物资材料',
             children: [
               {
                 id: 1,
                 choose: false,
                 title: '矿用油品(润滑油)',
                 type: '矿用油品(润滑油)',
               },
               {
                 id: 2,
                 choose: false,
                 title: '乳化油',
                 type: '乳化油',
               },
               {
                 id: 3,
                 choose: false,
                 title: '浓缩液',
                 type: '浓缩液',
               },
               {
                 id: 4,
                 choose: false,
                 title: '防冻液',
                 type: '防冻液',
               },
               {
                 id: 5,
                 choose: false,
                 title: '非金属安全材料',
                 type: '非金属安全材料',
               },
               {
                 id: 6,
                 choose: false,
                 title: '安全爆破器材',
                 type: '安全爆破器材',
               },
               {
                 id: 7,
                 choose: false,
                 title: '化学产品',
                 type: '化学产品',
               },
               {
                 id: 8,
                 choose: false,
                 title: '耐磨材料',
                 type: '耐磨材料',
               },
               {
                 id: 9,
                 choose: false,
                 title: '钢板',
                 type: '钢板',
               },
               {
                 id: 10,
                 choose: false,
                 title: '钢轨',
                 type: '钢轨',
               },
               {
                 id: 11,
                 choose: false,
                 title: '钢丝绳及检测服务',
                 type: '钢丝绳及检测服务',
               },
               {
                 id: 12,
                 choose: false,
                 title: '硬质合金',
                 type: '硬质合金',
               },
               {
                 id: 13,
                 choose: false,
                 title: '刀具',
                 type: '刀具',
               },
               {
                 id: 14,
                 choose: false,
                 title: '锂电池电源',
                 type: '锂电池电源',
               },
               {
                 id: 15,
                 choose: false,
                 title: '矿山专用轮胎',
                 type: '矿山专用轮胎',
               },
               {
                 id: 16,
                 choose: false,
                 title: '轮辋',
                 type: '轮辋',
               },
             ],
           },
           {
             id: 2,
             choose: false,
             title: '矿用工具、仪器、仪表',
             type: '矿用工具、仪器、仪表',
             children: [
               {
                 id: 1,
                 choose: false,
                 title: '手动',
                 type: '手动',
               },
               {
                 id: 2,
                 choose: false,
                 title: '电工',
                 type: '电工',
               },
               {
                 id: 3,
                 choose: false,
                 title: '动力工具',
                 type: '动力工具',
               },
               {
                 id: 4,
                 choose: false,
                 title: '物探',
                 type: '物探',
               },
               {
                 id: 5,
                 choose: false,
                 title: '测量仪器',
                 type: '测量仪器',
               },
               {
                 id: 6,
                 choose: false,
                 title: '温度',
                 type: '温度',
               },
               {
                 id: 7,
                 choose: false,
                 title: '气体',
                 type: '气体',
               },
               {
                 id: 8,
                 choose: false,
                 title: '压力检测仪器',
                 type: '压力检测仪器',
               },
               {
                 id: 9,
                 choose: false,
                 title: '煤质分析仪器',
                 type: '煤质分析仪器',
               },
               {
                 id: 10,
                 choose: false,
                 title: '自动化仪表',
                 type: '自动化仪表',
               },
             ],
           },
           {
             id: 3,
             choose: false,
             title: '加工制造',
             type: '加工制造',
             children: [
               {
                 id: 1,
                 choose: false,
                 title: '激光熔覆',
                 type: '激光熔覆',
               },
               {
                 id: 2,
                 choose: false,
                 title: '再制造',
                 type: '再制造',
               },
               {
                 id: 3,
                 choose: false,
                 title: '设备修造',
                 type: '设备修造',
               },
               {
                 id: 4,
                 choose: false,
                 title: '焊接技术',
                 type: '焊接技术',
               },
               {
                 id: 5,
                 choose: false,
                 title: '焊接材料',
                 type: '焊接材料',
               },
               {
                 id: 6,
                 choose: false,
                 title: '锻件加工',
                 type: '锻件加工',
               },
               {
                 id: 7,
                 choose: false,
                 title: '珩磨加工',
                 type: '珩磨加工',
               },
               {
                 id: 8,
                 choose: false,
                 title: '内喷雾',
                 type: '内喷雾',
               },
             ],
           },
         ],
       },
     ],
   };
      
export{
    screenList
}
